import { defineComponent as v, ref as u, onBeforeUnmount as rt, provide as lt, h as w, computed as c, Transition as st, inject as it, openBlock as n, createElementBlock as r, createElementVNode as t, createStaticVNode as a, normalizeStyle as dt, createBlock as b, resolveDynamicComponent as ct, unref as at, normalizeClass as f, createCommentVNode as m, renderSlot as _t } from "vue";
const k = /* @__PURE__ */ Symbol("FloatContext"), x = 10, y = (o) => {
  const e = it(k, null);
  if (e === null)
    throw new Error(`<${o}> is missing parent <Float /> component`);
  return e;
}, or = v({
  name: "Float",
  props: {
    anchor: {
      type: String,
      default: "right"
    },
    position: {
      type: String,
      default: void 0
    }
  },
  emits: ["close"],
  setup(o, { slots: e, emit: l }) {
    const s = {
      isActive: u(!1),
      x: u(0),
      y: u(0),
      closeFloat() {
        s.isActive.value = !1, l("close"), window.document.body.style.pointerEvents = "initial", window.removeEventListener("pointerdown", s.handleOutsideClick), window.removeEventListener("click", s.handleOutsideClick), window.removeEventListener("scroll", s.updatePosition, !0);
      },
      updatePosition() {
        const i = s.triggerRef.value?.getBoundingClientRect();
        i && (s.x.value = o.anchor === "right" ? i.right : i.left, s.y.value = i.bottom);
      },
      openFloat() {
        if (s.isActive.value) {
          s.closeFloat();
          return;
        }
        const i = s.triggerRef.value?.getBoundingClientRect();
        i && (s.isActive.value = !0, s.x.value = o.anchor === "right" ? i.right : i.left, s.y.value = i.bottom, window.addEventListener("scroll", s.updatePosition, !0), setTimeout(() => {
          window.addEventListener("pointerdown", s.handleOutsideClick), window.addEventListener("click", s.handleOutsideClick);
        }));
      },
      handleOutsideClick(i) {
        s.isActive.value && (s.componentRef.value?.contains(i.target) || s.triggerRef.value?.contains(i.target) || s.closeFloat());
      },
      parentRef: u(null),
      triggerRef: u(null),
      componentRef: u(null),
      anchor: o.anchor,
      position: o.position
    };
    return rt(() => {
      s.closeFloat();
    }), lt(k, s), () => w("div", { class: "w-fit", ref: s.parentRef }, e.default?.());
  }
}), nr = v({
  name: "FloatTrigger",
  setup(o, { slots: e }) {
    const l = y("FloatTrigger");
    return () => w("div", { onClick: l.openFloat, ref: l.triggerRef }, e.default?.());
  }
}), rr = v({
  name: "FloatComponent",
  setup(o, { slots: e }) {
    const l = y("FloatComponent"), s = c(() => {
      let i = l.y.value + x, d = l.x.value;
      const g = l.componentRef.value?.clientWidth || 0, _ = l.triggerRef.value?.getBoundingClientRect();
      l.anchor === "right" && (d -= g), d < 0 && _ ? d = _.left : d + g > window.innerWidth && _ && (d = _.right - g);
      const p = l.componentRef.value?.getBoundingClientRect();
      return (p?.bottom || 0) >= window.innerHeight && l.position !== "bottom" && (i = (_?.top || 0) - (p?.height || 0) - x), {
        top: `${i}px`,
        left: `${d}px`
      };
    });
    return () => w(
      st,
      { name: "float" },
      () => l.isActive.value && w(
        "div",
        {
          class: "z-100 fixed pointer-events-auto",
          style: s.value,
          ref: l.componentRef
        },
        e.default?.()
      )
    );
  }
}), ut = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function M(o, e) {
  return n(), r("svg", ut, [...e[0] || (e[0] = [
    t("path", {
      d: "M13 20.25a.375.375 0 0 1 0-.75M13 20.25a.375.375 0 0 0 0-.75M13 16.5V9",
      style: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M14.621 2.51a1.81 1.81 0 0 0-2.576-.737 1.8 1.8 0 0 0-.666.737L1.906 21.808A1.52 1.52 0 0 0 3.272 24h19.456a1.53 1.53 0 0 0 1.292-.717 1.52 1.52 0 0 0 .074-1.475z",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const gt = { render: M }, vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gt,
  render: M
}, Symbol.toStringTag, { value: "Module" })), pt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function j(o, e) {
  return n(), r("svg", pt, [...e[0] || (e[0] = [
    t("path", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.25 12h-3a.75.75 0 0 0-.75.75v9.75H8v-9.75a.75.75 0 0 0-.75-.75m7.5-9h-3a.75.75 0 0 0-.75.75V22.5h4.5V3.75a.75.75 0 0 0-.75-.75m7.5 4.5h-3a.75.75 0 0 0-.75.75V22.5H23V8.25a.75.75 0 0 0-.75-.75"
    }, null, -1)
  ])]);
}
const ft = { render: j }, wt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ft,
  render: j
}, Symbol.toStringTag, { value: "Module" })), ht = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function S(o, e) {
  return n(), r("svg", ht, [...e[0] || (e[0] = [
    t("rect", {
      width: "22",
      height: "20.429",
      x: "2",
      y: "2.786",
      rx: "1.571",
      ry: "1.571",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M2 7.5h22",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const mt = { render: S }, xt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mt,
  render: S
}, Symbol.toStringTag, { value: "Module" })), bt = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 20 25"
};
function I(o, e) {
  return n(), r("svg", bt, [...e[0] || (e[0] = [
    a('<defs><path id="AppleIcon_svg__a" d="M0 0h20v18.653H0z"></path><path id="AppleIcon_svg__c" d="M0 0h4.967v5.677H0z"></path></defs><g fill="none" fill-rule="evenodd"><g transform="translate(0 5.93)"><mask id="AppleIcon_svg__b" fill="#fff"><use xlink:href="#AppleIcon_svg__a"></use></mask><path fill="#292C30" d="M16.705 7.143c-.029-3.105 2.542-4.616 2.66-4.687C17.909.333 15.652.043 14.859.02c-1.895-.199-3.733 1.134-4.7 1.134-.984 0-2.471-1.114-4.073-1.08-2.062.03-3.991 1.225-5.05 3.078-2.182 3.78-.554 9.336 1.537 12.392 1.047 1.495 2.27 3.167 3.87 3.107 1.566-.065 2.15-.998 4.04-.998 1.873 0 2.422.998 4.054.96 1.68-.027 2.74-1.502 3.749-3.012 1.21-1.716 1.695-3.405 1.714-3.492-.039-.013-3.263-1.242-3.295-4.966" mask="url(#AppleIcon_svg__b)"></path></g><g transform="translate(9.938)"><mask id="AppleIcon_svg__d" fill="#fff"><use xlink:href="#AppleIcon_svg__c"></use></mask><path fill="#292C30" d="M3.683 3.94C4.524 2.888 5.1 1.455 4.94 0 3.722.054 2.197.843 1.32 1.874.542 2.78-.15 4.269.028 5.668c1.369.102 2.774-.69 3.654-1.727" mask="url(#AppleIcon_svg__d)"></path></g></g>', 2)
  ])]);
}
const kt = { render: I }, yt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kt,
  render: I
}, Symbol.toStringTag, { value: "Module" })), Mt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function O(o, e) {
  return n(), r("svg", Mt, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M3.599 18.125a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 0 0-5.25 0m6.852 6.375a4.474 4.474 0 0 0-8.449 0M10.251 11v2.25l-3-2.25H3.5A1.5 1.5 0 0 1 2 9.5v-6A1.5 1.5 0 0 1 3.5 2h8.251" }),
      t("path", { d: "M5 6.5 6.5 8l3.75-3m7.401 13.125a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 0 0-5.25 0m-1.6 6.375a4.474 4.474 0 0 1 8.449 0m-9.749-11.25h.75v2.25l3-2.25h4.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5h-8.25a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5m5.999-3-3.75-3m0 3 3.75-3" })
    ], -1)
  ])]);
}
const jt = { render: O }, St = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jt,
  render: O
}, Symbol.toStringTag, { value: "Module" })), It = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function $(o, e) {
  return n(), r("svg", It, [...e[0] || (e[0] = [
    t("path", {
      d: "M22.75 10.75v9.5a3 3 0 0 1-3 3H6.25a3 3 0 0 1-3-3v-9.5M22.75 2.75H3.25a1.5 1.5 0 0 0-1.5 1.5v3h22.5v-3a1.5 1.5 0 0 0-1.5-1.5",
      style: { fill: "none", "stroke-linecap": "square", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1),
    t("rect", {
      width: "7",
      height: "4",
      x: "9.5",
      y: "11.25",
      rx: "1.5",
      ry: "1.5",
      style: { fill: "none", "stroke-linecap": "square", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Ot = { render: $ }, $t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ot,
  render: $
}, Symbol.toStringTag, { value: "Module" })), zt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function z(o, e) {
  return n(), r("svg", zt, [...e[0] || (e[0] = [
    t("path", {
      d: "M13 25.03v-23",
      style: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M20.961 9.991 13 2.031l-7.961 7.96",
      style: { fill: "none", "stroke-linecap": "square", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Bt = { render: z }, Pt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bt,
  render: z
}, Symbol.toStringTag, { value: "Module" })), Tt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function B(o, e) {
  return n(), r("svg", Tt, [...e[0] || (e[0] = [
    t("path", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.5 9.5v7m9-7v7m10-7v7m-5-10.25v13.5M8 1.75v22.5"
    }, null, -1)
  ])]);
}
const Ct = { render: B }, At = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ct,
  render: B
}, Symbol.toStringTag, { value: "Module" })), Vt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function P(o, e) {
  return n(), r("svg", Vt, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "m19.05 11.803-4.7-4.7 2.524-2.526a1.97 1.97 0 0 1 2.783-.001h.001l1.918 1.919a1.97 1.97 0 0 1 0 2.783z" }),
      t("path", { d: "m19.05 11.803-4.7-4.7L8.276 9.65a2.22 2.22 0 0 0-1.522 1.527L4.021 21.446a.554.554 0 0 0 .685.685l10.273-2.734a2.22 2.22 0 0 0 1.523-1.52zM4.162 21.99l7.466-7.467" })
    ], -1)
  ])]);
}
const Ht = { render: P }, Lt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ht,
  render: P
}, Symbol.toStringTag, { value: "Module" })), Ft = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function T(o, e) {
  return n(), r("svg", Ft, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M21.688 23.23H4.312c-.85 0-1.541-.691-1.541-1.542V4.312c0-.85.69-1.541 1.541-1.541h17.376c.85 0 1.541.69 1.541 1.541v17.376c0 .85-.69 1.541-1.541 1.541ZM2.771 6.909h20.458" }),
      t("path", { d: "M19.058 14.965a6.058 6.058 0 1 1-12.116 0 6.058 6.058 0 0 1 12.116 0m1.556-10.177a.396.396 0 1 1-.796 0 .396.396 0 0 1 .796 0m-2.862 0a.396.396 0 1 1-.796 0 .396.396 0 0 1 .796 0" }),
      t("path", { d: "M14.33 14.965a1.33 1.33 0 1 1-2.659 0 1.33 1.33 0 0 1 2.659 0" })
    ], -1)
  ])]);
}
const Rt = { render: T }, qt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rt,
  render: T
}, Symbol.toStringTag, { value: "Module" })), Et = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
};
function C(o, e) {
  return n(), r("svg", Et, [...e[0] || (e[0] = [
    t("path", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.5 4H22a1.5 1.5 0 0 1 1.5 1.5V22a1.5 1.5 0 0 1-1.5 1.5H2.5A1.5 1.5 0 0 1 1 22V5.5A1.5 1.5 0 0 1 2.5 4M1 10h22.5M7 6.25V1m10.5 5.25V1"
    }, null, -1)
  ])]);
}
const Dt = { render: C }, Ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dt,
  render: C
}, Symbol.toStringTag, { value: "Module" })), Gt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function A(o, e) {
  return n(), r("svg", Gt, [...e[0] || (e[0] = [
    t("path", {
      d: "m3 15.044 4.083 5.795a1.748 1.748 0 0 0 2.845.085L23 4.386",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Nt = { render: A }, Wt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nt,
  render: A
}, Symbol.toStringTag, { value: "Module" })), Zt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function V(o, e) {
  return n(), r("svg", Zt, [...e[0] || (e[0] = [
    t("path", {
      d: "M20.961 16.98 13 9.02l-7.961 7.96",
      style: { fill: "none", "stroke-linecap": "square", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Qt = { render: V }, Yt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qt,
  render: V
}, Symbol.toStringTag, { value: "Module" })), Jt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};
function H(o, e) {
  return n(), r("svg", Jt, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#FFF",
      "stroke-width": "1.5",
      transform: "translate(1.5 1.5)"
    }, [
      t("circle", {
        cx: "9",
        cy: "9",
        r: "9.75",
        fill: "#AB0033"
      }),
      t("path", { d: "M9.125 14.25a.375.375 0 0 1 0-.75M9.125 14.25a.375.375 0 0 0 0-.75M9.126 10.5V3" })
    ], -1)
  ])]);
}
const Kt = { render: H }, Xt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kt,
  render: H
}, Symbol.toStringTag, { value: "Module" })), eo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function L(o, e) {
  return n(), r("svg", eo, [...e[0] || (e[0] = [
    t("circle", {
      cx: "12.833",
      cy: "13.359",
      r: "11.25",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "m6.583 14.504 2.45 3.477a1.05 1.05 0 0 0 1.707.051l7.843-9.923",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const to = { render: L }, oo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: to,
  render: L
}, Symbol.toStringTag, { value: "Module" })), no = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function F(o, e) {
  return n(), r("svg", no, [...e[0] || (e[0] = [
    t("circle", {
      cx: "13",
      cy: "13",
      r: "11.25",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M17.665 8.948a6.05 6.05 0 0 0-10.716 3.848v1.652M8.6 16.948a6.05 6.05 0 0 0 10.45-4.151v-1.1",
      style: { fill: "none", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "m4.75 12.246 2.2 2.2 2.2-2.2M21.25 13.896l-2.2-2.2-2.2 2.2",
      style: { fill: "none", "stroke-linecap": "square", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const ro = { render: F }, lo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ro,
  render: F
}, Symbol.toStringTag, { value: "Module" })), so = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function R(o, e) {
  return n(), r("svg", so, [...e[0] || (e[0] = [
    t("circle", {
      cx: "13",
      cy: "13",
      r: "11",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M13 13V9.071M13 13l4.91 4.911",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const io = { render: R }, co = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: io,
  render: R
}, Symbol.toStringTag, { value: "Module" })), ao = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function q(o, e) {
  return n(), r("svg", ao, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M4.625 9.125a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 0 0-8.25 0M2 21.5a6.75 6.75 0 1 1 13.5 0M15.602 11.375a3.375 3.375 0 1 0 6.75.004v-.004a3.375 3.375 0 1 0-6.75-.004zM17.063 16.318A5.526 5.526 0 0 1 24.5 21.5" })
    ], -1)
  ])]);
}
const _o = { render: q }, uo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _o,
  render: q
}, Symbol.toStringTag, { value: "Module" })), go = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function E(o, e) {
  return n(), r("svg", go, [...e[0] || (e[0] = [
    t("path", {
      d: "m15.983 6.109 6.667 6.667-6.667 6.667M9.25 19.443l-6.667-6.667L9.25 6.109",
      style: { fill: "none", "stroke-linecap": "square", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const vo = { render: E }, po = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vo,
  render: E
}, Symbol.toStringTag, { value: "Module" })), fo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function D(o, e) {
  return n(), r("svg", fo, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M9.5 14.785c0 1.963 1.085 3.551 3.64 3.551s3.36-1.69 3.36-2.767c0-1.724-1.252-2.605-3.36-2.936-2.502-.392-3.325-1.35-3.325-2.613 0-1.81 1.663-2.356 3.185-2.356s3.273.956 3.273 3.022M13 5v2.663m0 10.674V21" }),
      t("path", { d: "M2 13c0 6.076 4.924 11 11 11s11-4.924 11-11S19.076 2 13 2 2 6.924 2 13" })
    ], -1)
  ])]);
}
const wo = { render: D }, ho = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wo,
  render: D
}, Symbol.toStringTag, { value: "Module" })), mo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function U(o, e) {
  return n(), r("svg", mo, [...e[0] || (e[0] = [
    a('<defs><clipPath id="CopyIcon_svg__a"><path d="M0-.125h5v21H0z" style="fill:none;"></path></clipPath><clipPath id="CopyIcon_svg__b"><path d="M0-.125h23v5H0z" style="fill:none;"></path></clipPath></defs><rect width="17" height="17" x="7" y="6.875" rx="3" ry="3" style="fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><g style="clip-path:url(#CopyIcon_svg__a);"><path d="M5 1.875h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-11a3 3 0 0 1 3-3" style="fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></path></g><g style="clip-path:url(#CopyIcon_svg__b);"><path d="M5 1.875h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-11a3 3 0 0 1 3-3" style="fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></path></g>', 4)
  ])]);
}
const xo = { render: U }, bo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xo,
  render: U
}, Symbol.toStringTag, { value: "Module" })), ko = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function G(o, e) {
  return n(), r("svg", ko, [...e[0] || (e[0] = [
    t("path", {
      d: "m16.75 10.75-3.981 5.308a.75.75 0 0 1-1.13.08L9.25 13.75",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M11.73 2.358a1.63 1.63 0 0 1 2.54 0l1.512 1.881c.348.434.893.66 1.446.6l2.4-.261a1.63 1.63 0 0 1 1.8 1.8l-.261 2.4c-.06.553.166 1.098.6 1.446l1.881 1.512a1.63 1.63 0 0 1 0 2.54l-1.887 1.505a1.63 1.63 0 0 0-.6 1.447l.261 2.4a1.63 1.63 0 0 1-1.8 1.8l-2.4-.261a1.63 1.63 0 0 0-1.446.6l-1.506 1.874a1.63 1.63 0 0 1-2.54 0l-1.511-1.88a1.63 1.63 0 0 0-1.447-.6l-2.4.261a1.628 1.628 0 0 1-1.8-1.8l.261-2.4a1.63 1.63 0 0 0-.6-1.447l-1.88-1.511a1.63 1.63 0 0 1 0-2.54l1.88-1.512c.434-.348.66-.893.6-1.446l-.261-2.4a1.63 1.63 0 0 1 1.8-1.8l2.4.261a1.63 1.63 0 0 0 1.447-.6z",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const yo = { render: G }, Mo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yo,
  render: G
}, Symbol.toStringTag, { value: "Module" })), jo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function N(o, e) {
  return n(), r("svg", jo, [...e[0] || (e[0] = [
    t("path", {
      d: "M23.623 7.419h-3.146A9.3 9.3 0 0 1 22.335 13c0 5.147-4.187 9.334-9.334 9.334S3.666 18.147 3.666 13 7.853 3.666 13 3.666c1.021 0 2.003.167 2.923.471v3.282h-2.954c-3.099 0-5.62 2.521-5.62 5.62s2.521 5.62 5.62 5.62 5.62-2.521 5.62-5.62v-7.51h.001V2.381A11.94 11.94 0 0 0 13 .999C6.373 1 1 6.373 1 13s5.373 12 12 12 12-5.373 12-12a11.94 11.94 0 0 0-1.377-5.581m-7.7 5.62c0 1.629-1.325 2.954-2.954 2.954s-2.954-1.325-2.954-2.954 1.325-2.954 2.954-2.954h2.954z",
      style: { "fill-rule": "evenodd" }
    }, null, -1)
  ])]);
}
const So = { render: N }, Io = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: So,
  render: N
}, Symbol.toStringTag, { value: "Module" })), Oo = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 23 18"
};
function W(o, e) {
  return n(), r("svg", Oo, [...e[0] || (e[0] = [
    a('<defs><path id="DacrLicenseIcon_svg__a" d="M0 0h16.111v18H0z"></path></defs><g fill-rule="evenodd"><path d="M20.332 11.244a2.224 2.224 0 0 1-2.228-2.215V1.036h-2.012V9.03c0 2.324 1.903 4.215 4.24 4.215H23v-2z"></path><g><mask id="DacrLicenseIcon_svg__b" fill="#fff"><use xlink:href="#DacrLicenseIcon_svg__a"></use></mask><path d="M11.258 9.029c0 1.221-1 2.215-2.228 2.215A2.224 2.224 0 0 1 6.802 9.03c0-1.222 1-2.215 2.228-2.215h2.228zm3.422 4.176a7.05 7.05 0 0 1-5.627 2.796C5.17 16 2.011 12.86 2.011 9c0-3.86 3.16-7 7.042-7 .77 0 1.511.125 2.205.353v2.461H9.03c-2.338 0-4.24 1.89-4.24 4.215 0 2.324 1.902 4.214 4.24 4.214s4.24-1.89 4.24-4.214V3.396v.001-2.36A9.05 9.05 0 0 0 9.054 0C4.053 0 0 4.03 0 9s4.053 9 9.053 9a9.05 9.05 0 0 0 7.058-3.366 7 7 0 0 1-1.431-1.429" mask="url(#DacrLicenseIcon_svg__b)"></path></g></g>', 2)
  ])]);
}
const $o = { render: W }, zo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $o,
  render: W
}, Symbol.toStringTag, { value: "Module" })), Bo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Z(o, e) {
  return n(), r("svg", Bo, [...e[0] || (e[0] = [
    t("path", {
      d: "M19.417 24H6.583a1.833 1.833 0 0 1-1.833-1.833v-16.5h16.5v16.5A1.833 1.833 0 0 1 19.417 24M10.25 18.5v-7.333M15.75 18.5v-7.333M1.083 5.667h23.834M15.75 2h-5.5a1.833 1.833 0 0 0-1.833 1.833v1.833h9.167V3.833A1.833 1.833 0 0 0 15.751 2Z",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Po = { render: Z }, To = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Po,
  render: Z
}, Symbol.toStringTag, { value: "Module" })), Co = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Q(o, e) {
  return n(), r("svg", Co, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round"
    }, [
      t("path", {
        fill: "#F2C2C3",
        stroke: "#F2C2C3",
        "stroke-linecap": "round",
        "stroke-width": "1.5",
        d: "M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25",
        opacity: ".5"
      }),
      t("g", {
        stroke: "#A31A2C",
        "stroke-width": "2"
      }, [
        t("path", { d: "m6.853 17.203 10.35-10.35M6.853 6.853l10.35 10.35" })
      ])
    ], -1)
  ])]);
}
const Ao = { render: Q }, Vo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ao,
  render: Q
}, Symbol.toStringTag, { value: "Module" })), Ho = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Y(o, e) {
  return n(), r("svg", Ho, [...e[0] || (e[0] = [
    t("path", {
      d: "M13 1.625V18.96",
      style: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "m7 12.959 6 6 6-6M24 23.625H2",
      style: { fill: "none", "stroke-linecap": "square", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Lo = { render: Y }, Fo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Lo,
  render: Y
}, Symbol.toStringTag, { value: "Module" })), Ro = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function J(o, e) {
  return n(), r("svg", Ro, [...e[0] || (e[0] = [
    t("path", {
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.306 8.516a1.875 1.875 0 0 0 3.75.002v-.002a1.875 1.875 0 0 0-3.75-.002zm.547-1.324L3.17 2.75m11.885 5.901a1.874 1.874 0 1 0 3.749.001 1.874 1.874 0 0 0-3.749-.001m3.255-1.27 5.856-4.212m-.53 10.079H2.96m-.21 10.498 20.996.03m-19.495-.03 4.708-10.378 4.289 10.393 4.709-10.513 4.289 10.528M4.251 13.248v10.498m17.995-10.468v10.498"
    }, null, -1)
  ])]);
}
const qo = { render: J }, Eo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qo,
  render: J
}, Symbol.toStringTag, { value: "Module" })), Do = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function K(o, e) {
  return n(), r("svg", Do, [...e[0] || (e[0] = [
    t("path", {
      d: "M12.691 13.024 24 2M24 11.895V2H13.943M10.009 2H3.1A1.1 1.1 0 0 0 2 3.1v19.8A1.1 1.1 0 0 0 3.1 24h19.8a1.1 1.1 0 0 0 1.1-1.1v-6.909",
      style: { fill: "none", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Uo = { render: K }, Go = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Uo,
  render: K
}, Symbol.toStringTag, { value: "Module" })), No = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function X(o, e) {
  return n(), r("svg", No, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M13.249 7.001c-4.031-.068-8.2 2.75-10.821 5.634a1.663 1.663 0 0 0 0 2.226c2.564 2.824 6.72 5.706 10.82 5.637 4.1.07 8.259-2.813 10.825-5.637.57-.633.57-1.593 0-2.226-2.625-2.885-6.794-5.702-10.824-5.634" }),
      t("path", { d: "M16.998 13.75a3.75 3.75 0 1 1-7.5.004 3.75 3.75 0 0 1 7.5-.007z" })
    ], -1)
  ])]);
}
const Wo = { render: X }, Zo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wo,
  render: X
}, Symbol.toStringTag, { value: "Module" })), Qo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20.498 24"
};
function ee(o, e) {
  return n(), r("svg", Qo, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M19.748 21.75a1.5 1.5 0 0 1-1.5 1.5H2.25a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h13.043c.392 0 .768.153 1.048.426l2.954 2.883c.29.282.453.67.453 1.074zM5.295 8.25h9.998m-9.998 4.5h9.998m-9.998 4.5h6" })
    ], -1)
  ])]);
}
const Yo = { render: ee }, Jo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yo,
  render: ee
}, Symbol.toStringTag, { value: "Module" })), Ko = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function te(o, e) {
  return n(), r("svg", Ko, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M22.061 6.561c.281.281.439.662.439 1.06V22a2.25 2.25 0 0 1-1.391 2.077 2.3 2.3 0 0 1-.861.171H5.747A2.25 2.25 0 0 1 3.5 22V4a2.25 2.25 0 0 1 2.247-2.25h10.882a1.5 1.5 0 0 1 1.06.439z" }),
      t("path", { d: "M9.75 14.562c0 1.718.93 3.107 3.12 3.107s2.88-1.478 2.88-2.42c0-1.51-1.073-2.28-2.88-2.57-2.144-.343-2.85-1.181-2.85-2.287 0-1.583 1.426-2.061 2.73-2.061 1.306 0 2.806.836 2.806 2.645M12.75 6v2.331m0 9.338V20" })
    ], -1)
  ])]);
}
const Xo = { render: te }, en = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xo,
  render: te
}, Symbol.toStringTag, { value: "Module" })), tn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function oe(o, e) {
  return n(), r("svg", tn, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M22.498 22.75a1.5 1.5 0 0 1-1.5 1.5H5a1.5 1.5 0 0 1-1.5-1.5V3.25A1.5 1.5 0 0 1 5 1.75h13.043c.392 0 .768.153 1.048.426l2.954 2.883c.29.282.453.67.453 1.074zM8.045 9.25h9.998m-9.998 4.5h9.998m-9.998 4.5h6" })
    ], -1)
  ])]);
}
const on = { render: oe }, nn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: on,
  render: oe
}, Symbol.toStringTag, { value: "Module" })), rn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
};
function ne(o, e) {
  return n(), r("svg", rn, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round"
    }, [
      t("path", {
        fill: "#B8E7EA",
        stroke: "#B8E7EA",
        "stroke-linecap": "round",
        "stroke-width": "1.5",
        d: "M15 27.98c7.169 0 12.98-5.811 12.98-12.98S22.17 2.02 15 2.02C7.831 2.02 2.02 7.83 2.02 15c0 7.169 5.811 12.98 12.98 12.98"
      }),
      t("path", {
        stroke: "#003C4D",
        "stroke-width": "2",
        d: "m8.077 16.61 2.827 4.012a1.21 1.21 0 0 0 1.97.058l9.049-11.45"
      })
    ], -1)
  ])]);
}
const ln = { render: ne }, sn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ln,
  render: ne
}, Symbol.toStringTag, { value: "Module" })), dn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function re(o, e) {
  return n(), r("svg", dn, [...e[0] || (e[0] = [
    t("path", {
      d: "M3 5.957h20M5.13 10.652h15.74M10.084 20.043h5.831M7.26 15.348h11.48",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.667px" }
    }, null, -1)
  ])]);
}
const cn = { render: re }, an = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cn,
  render: re
}, Symbol.toStringTag, { value: "Module" })), _n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
};
function le(o, e) {
  return n(), r("svg", _n, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M12.25 1C18.463 1 23.5 6.037 23.5 12.25S18.463 23.5 12.25 23.5 1 18.463 1 12.25 6.037 1 12.25 1" }),
      t("path", { d: "M10.13 23.3c-1.57-2.2-2.63-6.33-2.63-11s1.06-8.9 2.63-11.05M14.37 23.3c1.57-2.2 2.63-6.33 2.63-11s-1.06-8.9-2.63-11.05M1 12.25h22.5M2.3 17.5h19.9M2.3 7h19.9" })
    ], -1)
  ])]);
}
const un = { render: le }, gn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: un,
  render: le
}, Symbol.toStringTag, { value: "Module" })), vn = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 22 24"
};
function se(o, e) {
  return n(), r("svg", vn, [...e[0] || (e[0] = [
    a('<defs><path id="GoogleIcon_svg__a" d="M0 0h17.56v9.084H0z"></path></defs><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M22 12.24c0-.821-.073-1.607-.21-2.362H11.234v4.328l6.08.001a5.2 5.2 0 0 1-2.256 3.487v2.808h3.618C20.79 18.546 22 15.655 22 12.24"></path><path fill="#34A853" d="M15.059 17.694c-1.007.68-2.305 1.077-3.822 1.077-2.932 0-5.419-1.976-6.31-4.638H1.196v2.896a11.24 11.24 0 0 0 10.042 6.188c3.035 0 5.585-.998 7.44-2.716z"></path><path fill="#FABB05" d="M4.576 11.984c0-.748.125-1.47.352-2.15V6.938H1.195A11.2 11.2 0 0 0 0 11.984c0 1.815.432 3.528 1.195 5.046l3.733-2.896a6.8 6.8 0 0 1-.352-2.15"></path><g transform="translate(1.195 .75)"><mask id="GoogleIcon_svg__b" fill="#fff"><use xlink:href="#GoogleIcon_svg__a"></use></mask><path fill="#E94235" d="M10.042 4.446c1.656 0 3.14.571 4.311 1.686l3.207-3.204C15.612 1.114 13.073 0 10.042 0 5.652 0 1.849 2.518 0 6.188l3.733 2.896c.89-2.662 3.377-4.638 6.309-4.638" mask="url(#GoogleIcon_svg__b)"></path></g></g>', 2)
  ])]);
}
const pn = { render: se }, fn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pn,
  render: se
}, Symbol.toStringTag, { value: "Module" })), wn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function ie(o, e) {
  return n(), r("svg", wn, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M13.562 18.84a1.51 1.51 0 0 1 1.24-1.65 3 3 0 0 0 1.66-.83c1.48-1.42 1.1-4.2-.82-6.12s-4.7-2.3-6.12-.82a3 3 0 0 0-.83 1.66 1.51 1.51 0 0 1-1.65 1.24 4.7 4.7 0 0 0-4 1.25c-2.03 2.05-1.62 5.78.9 8.37s6.29 3 8.34.91a4.7 4.7 0 0 0 1.28-4.01m5.79-14.427 1.591-1.591a1.5 1.5 0 1 1 2.121 2.12l-1.59 1.592a1.5 1.5 0 1 1-2.122-2.121m0 2.117-3.71 3.71m4.239-8.49 1.061 1.06m2.13 2.13L24.131 6m-2.649.53 1.059 1.06m-4.25-4.25 1.061 1.06" }),
      t("path", { d: "M11.931 12.45a1.5 1.5 0 1 1 0 3.001 1.5 1.5 0 0 1 0-3.001m-5.83 5.21 2.12 2.12" })
    ], -1)
  ])]);
}
const hn = { render: ie }, mn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hn,
  render: ie
}, Symbol.toStringTag, { value: "Module" })), xn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function de(o, e) {
  return n(), r("svg", xn, [...e[0] || (e[0] = [
    t("path", {
      d: "M3.78 22 22.53 4M10 20.05a9.9 9.9 0 0 0 3 .45c4.1.07 8.26-2.81 10.82-5.64a1.65 1.65 0 0 0 0-2.22 20 20 0 0 0-3.07-2.76M18.09 8.27A11.3 11.3 0 0 0 13 7c-4-.07-8.2 2.75-10.82 5.64a1.65 1.65 0 0 0 0 2.22 20 20 0 0 0 4.93 4",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M10 16.07a3.85 3.85 0 0 1 5.5-5.28M16.75 13.75A3.75 3.75 0 0 1 13 17.5",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const bn = { render: de }, kn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bn,
  render: de
}, Symbol.toStringTag, { value: "Module" })), yn = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "fill-rule": "evenodd",
  "stroke-width": "1.5",
  viewBox: "0 0 18 19"
};
function ce(o, e) {
  return n(), r("svg", yn, [...e[0] || (e[0] = [
    t("path", { d: "M17 9.196 1 1v16.393z" }, null, -1)
  ])]);
}
const Mn = { render: ce }, jn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mn,
  render: ce
}, Symbol.toStringTag, { value: "Module" })), Sn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function ae(o, e) {
  return n(), r("svg", Sn, [...e[0] || (e[0] = [
    t("path", {
      d: "M23.631 10.016 13.005 1.999 2.369 10.016c-.22.203-.352.483-.369.782v12.244a.96.96 0 0 0 .956.956h6.377v-5.13a3.667 3.667 0 0 1 7.334 0v5.133h6.376a.96.96 0 0 0 .957-.956V10.798a1.15 1.15 0 0 0-.369-.782",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const In = { render: ae }, On = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: In,
  render: ae
}, Symbol.toStringTag, { value: "Module" })), $n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
};
function _e(o, e) {
  return n(), r("svg", $n, [...e[0] || (e[0] = [
    a('<g fill="none" fill-rule="evenodd"><path d="M594-545c6.075 0 11 4.925 11 11V774c0 6.075-4.925 11-11 11H-40c-6.075 0-11-4.925-11-11V-534c0-5.656 4.29-10.376 9.874-10.943l1.176-.058Z"></path><g stroke-width="1.5"><path d="M2.538 4.654a2.96 2.96 0 1 0 5.922.001 2.96 2.96 0 0 0-5.922-.001M20.308 19.462l-5.397-7.86a1.416 1.416 0 0 0-1.927-.376q-.218.141-.37.35l-3.7 5.133-2.293-1.786a1.42 1.42 0 0 0-2.026.306l-2.903 4.233"></path></g><path fill-rule="nonzero" d="M5.5 1.058a3.596 3.596 0 1 0-.001 7.19 3.596 3.596 0 0 0 .001-7.19m0 1.269a2.326 2.326 0 1 1 .001 4.653A2.326 2.326 0 0 1 5.5 2.327m7.14 8.366a2.053 2.053 0 0 1 2.71.436l.085.114 5.755 8.383-1.046.718-5.756-8.383a.782.782 0 0 0-1.2-.084l-.06.071-4.084 5.667-2.812-2.19a.786.786 0 0 0-1.081.12l-.033.043-3.261 4.756-1.047-.718 3.265-4.761.07-.096.033-.04a2.053 2.053 0 0 1 2.712-.394l.121.088 1.773 1.38 3.316-4.598q.176-.244.417-.426z"></path></g>', 1)
  ])]);
}
const zn = { render: _e }, Bn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zn,
  render: _e
}, Symbol.toStringTag, { value: "Module" })), Pn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function ue(o, e) {
  return n(), r("svg", Pn, [...e[0] || (e[0] = [
    t("path", {
      d: "M15.25 17.5h-.75A1.503 1.503 0 0 1 13 16v-3.75a.75.75 0 0 0-.22-.53.75.75 0 0 0-.53-.22h-.75",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("circle", {
      cx: "12.625",
      cy: "8.125",
      r: ".375",
      style: { fill: "#2d2d2d", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1),
    t("circle", {
      cx: "13",
      cy: "13",
      r: "11.25",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Tn = { render: ue }, Cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tn,
  render: ue
}, Symbol.toStringTag, { value: "Module" })), An = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function ge(o, e) {
  return n(), r("svg", An, [...e[0] || (e[0] = [
    a('<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="m20.9 2-3.75 2.25L19.4 8"></path><path d="M24.5 9.44a6.73 6.73 0 0 0-6.88-4.42M5.6 24.5l3.75-2.25L7.1 18.5"></path><path d="M2 17.06a6.73 6.73 0 0 0 6.88 4.42M3.5 2h9A1.5 1.5 0 0 1 14 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 12.5v-9A1.5 1.5 0 0 1 3.5 2M17 12.5h6a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-6m4.25 2.25h3.5M8 5v1.5m-3 0h6"></path><path d="M9.5 6.5S8 11 5 11"></path><path d="M8 9.25a3.92 3.92 0 0 0 3 1.73m5.75 10.52v-4a1.75 1.75 0 0 1 3.5 0v4"></path></g>', 1)
  ])]);
}
const Vn = { render: ge }, Hn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vn,
  render: ge
}, Symbol.toStringTag, { value: "Module" })), Ln = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function ve(o, e) {
  return n(), r("svg", Ln, [...e[0] || (e[0] = [
    t("path", {
      d: "M2.813 12.99h19.866M1.72 13.009c8.128 0 10.982-7.358 10.982-7.358l1.621-3.805",
      style: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M1.72 12.99c8.128 0 10.982 7.359 10.982 7.359l1.621 3.671M20.22 10l3 3-3 3M10.367 3.092l3.987-1.451 1.451 3.986",
      style: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "m15.805 20.373-1.451 3.986-3.987-1.451",
      style: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Fn = { render: ve }, Rn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fn,
  render: ve
}, Symbol.toStringTag, { value: "Module" })), qn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 23"
};
function pe(o, e) {
  return n(), r("svg", qn, [...e[0] || (e[0] = [
    t("path", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10 22h3m4.5-10.5a6 6 0 0 0-5.979-6.021A6 6 0 0 0 10 17.288V19h3v-1.712a5.99 5.99 0 0 0 4.5-5.788m-6-9V1m9 9H22M1 11.5h1.5m15.364 5.614 1.061 1.061M4.075 3.325l1.061 1.061m12.728 0 1.061-1.061m-14.85 14.85 1.061-1.061"
    }, null, -1)
  ])]);
}
const En = { render: pe }, Dn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: En,
  render: pe
}, Symbol.toStringTag, { value: "Module" })), Un = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 13"
};
function fe(o, e) {
  return n(), r("svg", Un, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "m1.847 6.5 8.52-.018" }),
      t("path", {
        "stroke-linecap": "square",
        "stroke-linejoin": "round",
        d: "m6.692 10.156 3.674-3.674-3.674-3.674"
      })
    ], -1)
  ])]);
}
const Gn = { render: fe }, Nn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gn,
  render: fe
}, Symbol.toStringTag, { value: "Module" })), Wn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function we(o, e) {
  return n(), r("svg", Wn, [...e[0] || (e[0] = [
    t("path", {
      d: "M13.442 19.484a4.97 4.97 0 0 1-6.597 2.376 4.97 4.97 0 0 1-2.376-6.597l1.508-3.204a4.97 4.97 0 0 1 6.596-2.376 4.96 4.96 0 0 1 2.739 3.481",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M12.559 6.516a4.97 4.97 0 0 1 6.597-2.376 4.97 4.97 0 0 1 2.376 6.596l-1.508 3.204a4.97 4.97 0 0 1-6.597 2.376 4.94 4.94 0 0 1-2.566-2.857",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Zn = { render: we }, Qn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zn,
  render: we
}, Symbol.toStringTag, { value: "Module" })), Yn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function he(o, e) {
  return n(), r("svg", Yn, [...e[0] || (e[0] = [
    t("path", {
      d: "M13 1.75V5.5M13 24.25V20.5M5.045 5.045l2.652 2.652M20.955 20.955l-2.652-2.651M1.75 13H5.5M24.25 13H20.5M5.045 20.955l2.652-2.651M20.955 5.045l-2.652 2.652",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Jn = { render: he }, Kn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jn,
  render: he
}, Symbol.toStringTag, { value: "Module" })), Xn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function me(o, e) {
  return n(), r("svg", Xn, [...e[0] || (e[0] = [
    t("rect", {
      width: "16.5",
      height: "13.5",
      x: "4.75",
      y: "10.75",
      rx: "1.5",
      ry: "1.5",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M7.75 10.75V7a5.25 5.25 0 0 1 10.5 0v3.75M13 16v3",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const e1 = { render: me }, t1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e1,
  render: me
}, Symbol.toStringTag, { value: "Module" })), o1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 80"
};
function xe(o, e) {
  return n(), r("svg", o1, [...e[0] || (e[0] = [
    t("circle", {
      cx: "40",
      cy: "40",
      r: "40",
      fill: "#7B3FE4"
    }, null, -1),
    t("path", {
      fill: "#fff",
      d: "M66.666 40.934V53a4.36 4.36 0 0 1-2.133 3.722l-10.417 6.02a4.16 4.16 0 0 1-4.266 0l-10.417-6.02a4.36 4.36 0 0 1-2.133-3.721v-3.388l5.333-3.106v5.887l9.333 5.436 9.334-5.436V41.548l-9.334-5.436L30.1 48.825a4.33 4.33 0 0 1-4.267 0l-10.417-6.046a4.36 4.36 0 0 1-2.083-3.717V26.992a4.36 4.36 0 0 1 2.133-3.721l10.417-6.022a4.19 4.19 0 0 1 4.267 0l10.416 6.022a4.36 4.36 0 0 1 2.133 3.721v3.387l-5.366 3.086v-5.854L28 22.176l-9.334 5.436v10.834L28 43.882 49.866 31.17a4.33 4.33 0 0 1 4.267 0l10.417 6.046a4.34 4.34 0 0 1 2.116 3.718"
    }, null, -1)
  ])]);
}
const n1 = { render: xe }, r1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n1,
  render: xe
}, Symbol.toStringTag, { value: "Module" })), l1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 17.5"
};
function be(o, e) {
  return n(), r("svg", l1, [...e[0] || (e[0] = [
    t("path", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M.75 16.75h19.5m-19.5-8h19.5M.75.75h19.5"
    }, null, -1)
  ])]);
}
const s1 = { render: be }, i1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: s1,
  render: be
}, Symbol.toStringTag, { value: "Module" })), d1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function ke(o, e) {
  return n(), r("svg", d1, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M7.938 23.664h9.961m-4.981-5.976v5.977M21.086 9.52a8.169 8.169 0 0 1-16.336 0" }),
      t("path", { d: "M16.902 5.734a3.984 3.984 0 1 0-7.969 0v3.984a3.985 3.985 0 1 0 7.97 0zM8.934 9.002h7.969" })
    ], -1)
  ])]);
}
const c1 = { render: ke }, a1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: c1,
  render: ke
}, Symbol.toStringTag, { value: "Module" })), _1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 3"
};
function ye(o, e) {
  return n(), r("svg", _1, [...e[0] || (e[0] = [
    t("path", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "square",
      "stroke-width": "1.5",
      d: "M1.5 1.5h13"
    }, null, -1)
  ])]);
}
const u1 = { render: ye }, g1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u1,
  render: ye
}, Symbol.toStringTag, { value: "Module" })), v1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Me(o, e) {
  return n(), r("svg", v1, [...e[0] || (e[0] = [
    a('<path d="M13.072 10.822v13.356" style="fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></path><path d="m9.117 20.263 3.955 3.914 3.943-3.914" style="fill:none;stroke-linecap:square;stroke-miterlimit:10;stroke-width:1.5px;"></path><path d="M13.06 15.178V1.822" style="fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></path><path d="M17.015 5.737 13.06 1.823 9.117 5.737" style="fill:none;stroke-linecap:square;stroke-miterlimit:10;stroke-width:1.5px;"></path><path d="M10.822 12.886h13.356" style="fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></path><path d="m20.263 16.841 3.914-3.955-3.914-3.943" style="fill:none;stroke-linecap:square;stroke-miterlimit:10;stroke-width:1.5px;"></path><path d="M15.178 12.898H1.822" style="fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></path><path d="m5.737 8.943-3.914 3.955 3.914 3.943" style="fill:none;stroke-linecap:square;stroke-miterlimit:10;stroke-width:1.5px;"></path>', 8)
  ])]);
}
const p1 = { render: Me }, f1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: p1,
  render: Me
}, Symbol.toStringTag, { value: "Module" })), w1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function je(o, e) {
  return n(), r("svg", w1, [...e[0] || (e[0] = [
    t("path", {
      d: "M11 22.75a2.087 2.087 0 0 0 4.005 0M13 4V1.75M13 4a7.5 7.5 0 0 1 7.5 7.5c0 7.046 1.5 8.25 1.5 8.25H4s1.5-1.916 1.5-8.25A7.5 7.5 0 0 1 13 4",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const h1 = { render: je }, m1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: h1,
  render: je
}, Symbol.toStringTag, { value: "Module" })), x1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 24"
};
function Se(o, e) {
  return n(), r("svg", x1, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M8.75.75h11.5a1 1 0 0 1 1 1v21a.5.5 0 0 1-.5.5H8.25a.5.5 0 0 1-.5-.5v-21a1 1 0 0 1 1-1m-1 12v10a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5m-3.284 3.632v2.368M12 10.816v2.368m4.854-2.368v2.368M12 4.635v2.368m4.854-2.368v2.368" }),
      t("path", { d: "M14.359 17.75c-.93 0-1.684.754-1.684 1.684v3.816h3.368v-3.816c0-.93-.754-1.684-1.684-1.684" })
    ], -1)
  ])]);
}
const b1 = { render: Se }, k1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: b1,
  render: Se
}, Symbol.toStringTag, { value: "Module" })), y1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Ie(o, e) {
  return n(), r("svg", y1, [...e[0] || (e[0] = [
    t("path", {
      fill: "#292C30",
      "fill-rule": "evenodd",
      d: "M4 2h7v22H4zm11 0h7v22h-7z"
    }, null, -1)
  ])]);
}
const M1 = { render: Ie }, j1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M1,
  render: Ie
}, Symbol.toStringTag, { value: "Module" })), S1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Oe(o, e) {
  return n(), r("svg", S1, [...e[0] || (e[0] = [
    t("path", {
      d: "M23.19 2.81a3.64 3.64 0 0 0-5.146.011l-.024.024-14.5 14.5-1.77 6.905 6.905-1.771 14.5-14.5a3.637 3.637 0 0 0 .061-5.143zM17.606 3.26l5.134 5.134M3.521 17.344l5.139 5.13",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const I1 = { render: Oe }, O1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I1,
  render: Oe
}, Symbol.toStringTag, { value: "Module" })), $1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 18"
};
function $e(o, e) {
  return n(), r("svg", $1, [...e[0] || (e[0] = [
    t("path", {
      fill: "#292C30",
      d: "M.885 1.39c0-.521.406-.858.748-.62l10.972 7.61c.373.259.373.981 0 1.24L1.633 17.23c-.342.238-.748-.099-.748-.62Z"
    }, null, -1)
  ])]);
}
const z1 = { render: $e }, B1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z1,
  render: $e
}, Symbol.toStringTag, { value: "Module" })), P1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function ze(o, e) {
  return n(), r("svg", P1, [...e[0] || (e[0] = [
    t("path", {
      d: "M1.75 13h22.5M13 1.75v22.5",
      style: { fill: "none", "stroke-linecap": "square", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const T1 = { render: ze }, C1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: T1,
  render: ze
}, Symbol.toStringTag, { value: "Module" })), A1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Be(o, e) {
  return n(), r("svg", A1, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M13.05 24.5c6.213 0 11.25-5.037 11.25-11.25S19.263 2 13.05 2 1.8 7.037 1.8 13.25 6.837 24.5 13.05 24.5" }),
      t("path", { d: "M13 7a4.262 4.262 0 1 1 0 8.524A4.262 4.262 0 0 1 13 7m7.37 14.904c-2.038-3.866-7.193-5.677-11.059-3.64-1.412.744-2.9 2.149-3.644 3.561" })
    ], -1)
  ])]);
}
const V1 = { render: Be }, H1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: V1,
  render: Be
}, Symbol.toStringTag, { value: "Module" })), L1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24"
};
function Pe(o, e) {
  return n(), r("svg", L1, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M1 12.002h15.75M13 15.752l3.75-3.75L13 8.252" }),
      t("path", { d: "M3.556 16.598c2.538 5.214 8.822 7.383 14.036 4.845s7.384-8.822 4.846-14.036S13.615.023 8.401 2.562a10.5 10.5 0 0 0-4.666 4.494" })
    ], -1)
  ])]);
}
const F1 = { render: Pe }, R1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F1,
  render: Pe
}, Symbol.toStringTag, { value: "Module" })), q1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Te(o, e) {
  return n(), r("svg", q1, [...e[0] || (e[0] = [
    t("rect", {
      width: "22",
      height: "10.267",
      x: "2",
      y: "7.867",
      rx: "1.467",
      ry: "1.467",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M18.133 19.6V6.4M13.733 24a4.4 4.4 0 0 0 4.4-4.4 4.4 4.4 0 0 0 4.4 4.4M13.733 2a4.4 4.4 0 0 1 4.4 4.4 4.4 4.4 0 0 1 4.4-4.4",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const E1 = { render: Te }, D1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E1,
  render: Te
}, Symbol.toStringTag, { value: "Module" })), U1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Ce(o, e) {
  return n(), r("svg", U1, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#2d2d2d",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M8.5 15 2 8.5 8.5 2" }),
      t("path", {
        "stroke-linecap": "round",
        d: "M11 23.5h6a7.5 7.5 0 0 0 0-15H2"
      })
    ], -1)
  ])]);
}
const G1 = { render: Ce }, N1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G1,
  render: Ce
}, Symbol.toStringTag, { value: "Module" })), W1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Ae(o, e) {
  return n(), r("svg", W1, [...e[0] || (e[0] = [
    t("path", {
      d: "M2.583 14.469a9.063 9.063 0 1 0 16.681-7.09 9.063 9.063 0 0 0-16.681 7.09M17.332 17.332l7.029 7.03",
      style: { fill: "none", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const Z1 = { render: Ae }, Q1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z1,
  render: Ae
}, Symbol.toStringTag, { value: "Module" })), Y1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Ve(o, e) {
  return n(), r("svg", Y1, [...e[0] || (e[0] = [
    t("path", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m19.5 16.5-6.499 6-6.501-6m0-7 6.499-6 6.501 6"
    }, null, -1)
  ])]);
}
const J1 = { render: Ve }, K1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J1,
  render: Ve
}, Symbol.toStringTag, { value: "Module" })), X1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.569 23.578"
};
function He(o, e) {
  return n(), r("svg", X1, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M1.834 10.175a1.487 1.487 0 0 1-.07-2.841L21.837.788a.751.751 0 0 1 .948.943l-6.541 20.08a1.486 1.486 0 0 1-2.841-.07l-2.246-9.33zM22.598.967 11.155 12.41" })
    ], -1)
  ])]);
}
const e0 = { render: He }, t0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e0,
  render: He
}, Symbol.toStringTag, { value: "Module" })), o0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Le(o, e) {
  return n(), r("svg", o0, [...e[0] || (e[0] = [
    t("path", {
      d: "M11.545 3.441a1.957 1.957 0 0 0 2.908 0l.946-1.038a1.958 1.958 0 0 1 3.41 1.413l-.071 1.4a1.96 1.96 0 0 0 2.051 2.054l1.4-.071a1.959 1.959 0 0 1 1.41 3.41l-1.042.94a1.96 1.96 0 0 0 0 2.909l1.042.94a1.958 1.958 0 0 1-1.413 3.41l-1.4-.071a1.96 1.96 0 0 0-2.056 2.056l.071 1.4a1.959 1.959 0 0 1-3.402 1.41l-.941-1.041a1.96 1.96 0 0 0-2.908 0l-.945 1.041a1.959 1.959 0 0 1-3.406-1.408l.072-1.4a1.96 1.96 0 0 0-2.056-2.056l-1.4.071a1.957 1.957 0 0 1-1.416-3.407l1.041-.94a1.96 1.96 0 0 0 0-2.909l-1.041-.945a1.959 1.959 0 0 1 1.409-3.406l1.4.071a1.96 1.96 0 0 0 2.058-2.06l-.067-1.401a1.959 1.959 0 0 1 3.406-1.41z",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("circle", {
      cx: "12.999",
      cy: "13.004",
      r: "4.5",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const n0 = { render: Le }, r0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n0,
  render: Le
}, Symbol.toStringTag, { value: "Module" })), l0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Fe(o, e) {
  return n(), r("svg", l0, [...e[0] || (e[0] = [
    t("path", {
      d: "M18.25 9.405h1.5a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5H6.25a1.5 1.5 0 0 1-1.5-1.5v-12a1.5 1.5 0 0 1 1.5-1.5h1.5M13 2.906v9.499M9.25 5.655 13 1.905l3.75 3.75",
      style: { fill: "none", "stroke-linecap": "square", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const s0 = { render: Fe }, i0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: s0,
  render: Fe
}, Symbol.toStringTag, { value: "Module" })), d0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Re(o, e) {
  return n(), r("svg", d0, [...e[0] || (e[0] = [
    t("path", {
      d: "M1.75 13H17.5M13.75 16.75 17.5 13l-3.75-3.75",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M4.306 17.596c2.538 5.214 8.822 7.383 14.036 4.845s7.384-8.822 4.846-14.036S14.365 1.021 9.151 3.56a10.5 10.5 0 0 0-4.666 4.494",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const c0 = { render: Re }, a0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: c0,
  render: Re
}, Symbol.toStringTag, { value: "Module" })), _0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function qe(o, e) {
  return n(), r("svg", _0, [...e[0] || (e[0] = [
    t("path", {
      d: "M8.091 6.612v12.777M4 9.667 8.091 5.5l4.091 4.167M17.909 19.388V6.611M22 16.333 17.909 20.5l-4.091-4.167",
      style: { fill: "none", "stroke-linecap": "square", "stroke-miterlimit": "10", "stroke-width": "1.682px" }
    }, null, -1)
  ])]);
}
const u0 = { render: qe }, g0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u0,
  render: qe
}, Symbol.toStringTag, { value: "Module" })), v0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
};
function Ee(o, e) {
  return n(), r("svg", v0, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      transform: "translate(.75 .75)"
    }, [
      t("path", {
        stroke: "#292C30",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M5.25 7.524v-2.05H4.145"
      }),
      t("circle", {
        cx: "5.25",
        cy: "3.188",
        r: "1",
        fill: "#292C30"
      }),
      t("rect", {
        width: "10.5",
        height: "10.5",
        stroke: "#292C30",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        rx: "3"
      })
    ], -1)
  ])]);
}
const p0 = { render: Ee }, f0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: p0,
  render: Ee
}, Symbol.toStringTag, { value: "Module" })), w0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 20"
};
function De(o, e) {
  return n(), r("svg", w0, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "m11 5.5 6.5 6.5-6.5 6.5" }),
      t("path", { d: "M1.018 1.062V4.5a7.5 7.5 0 0 0 7.5 7.5H17.5" })
    ], -1)
  ])]);
}
const h0 = { render: De }, m0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: h0,
  render: De
}, Symbol.toStringTag, { value: "Module" })), x0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 20"
};
function Ue(o, e) {
  return n(), r("svg", x0, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M19.503 4.59A8.386 8.386 0 0 0 7.631 3.446a8.53 8.53 0 0 0-3.064 6.552v2.322M6.867 15.833a8.384 8.384 0 0 0 11.92.348 8.54 8.54 0 0 0 2.646-6.183V8.452" }),
      t("path", { d: "m1.5 9.225 3.067 3.092 3.066-3.092M24.5 11.544l-3.067-3.092-3.066 3.092" })
    ], -1)
  ])]);
}
const b0 = { render: Ue }, k0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: b0,
  render: Ue
}, Symbol.toStringTag, { value: "Module" })), y0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Ge(o, e) {
  return n(), r("svg", y0, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M20.119 11.907a1.757 1.757 0 1 1 0 3.515 1.757 1.757 0 0 1 0-3.515m2.87 5.707a3.627 3.627 0 0 0-5.732 0M5.881 11.907a1.757 1.757 0 1 1 0 3.515 1.757 1.757 0 0 1 0-3.515M3.01 17.613a3.627 3.627 0 0 1 5.73-.008" }),
      t("path", { d: "M17.481 19a4.48 4.48 0 0 0-4.482-4.48A4.48 4.48 0 0 0 8.519 19m4.435-11a2.649 2.649 0 1 1-.001 5.297A2.649 2.649 0 0 1 12.954 8" }),
      t("path", { d: "M13 1.75c6.213 0 11.25 5.037 11.25 11.25S19.213 24.25 13 24.25 1.75 19.213 1.75 13 6.787 1.75 13 1.75" })
    ], -1)
  ])]);
}
const M0 = { render: Ge }, j0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M0,
  render: Ge
}, Symbol.toStringTag, { value: "Module" })), S0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Ne(o, e) {
  return n(), r("svg", S0, [...e[0] || (e[0] = [
    t("path", {
      d: "M1.75 20.5h11.5M1.75 15.5h22.5M1.75 10.5h22.5M1.75 5.5h22.5",
      style: { fill: "none", "stroke-linecap": "square", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const I0 = { render: Ne }, O0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I0,
  render: Ne
}, Symbol.toStringTag, { value: "Module" })), $0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function We(o, e) {
  return n(), r("svg", $0, [...e[0] || (e[0] = [
    a('<circle cx="4.25" cy="13" r="1.75" style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;"></circle><circle cx="21.75" cy="13" r="1.75" style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;"></circle><circle cx="13" cy="13" r="1.75" style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;"></circle><circle cx="4.25" cy="13" r="1.75"></circle><circle cx="13" cy="13" r="1.75"></circle><circle cx="21.75" cy="13" r="1.75"></circle>', 6)
  ])]);
}
const z0 = { render: We }, B0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z0,
  render: We
}, Symbol.toStringTag, { value: "Module" })), P0 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.716",
  viewBox: "0 0 16 16"
};
function Ze(o, e) {
  return n(), r("svg", P0, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      t("path", { d: "M3.815 6.784c2.478-.191 3.272-1.888 3.775-4.4 0-.993 2.853-1.124 2.853.762-.096 1.247-.324 1.856-.681 3.055h3.873a1.25 1.25 0 0 1 1.212 1.555l-1.25 5.623a1.25 1.25 0 0 1-1.211.949h-8.57" }),
      t("path", { d: "M1.838 6.139h1.977v8.189H1.838a.953.953 0 0 1-.953-.953V7.091c0-.526.427-.952.953-.952" })
    ], -1)
  ])]);
}
const T0 = { render: Ze }, C0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: T0,
  render: Ze
}, Symbol.toStringTag, { value: "Module" })), A0 = { viewBox: "0 0 26 26" };
function Qe(o, e) {
  return n(), r("svg", A0, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M3.25 1.75h19.5a1.5 1.5 0 0 1 1.5 1.5v19.5a1.5 1.5 0 0 1-1.5 1.5H3.25a1.5 1.5 0 0 1-1.5-1.5V3.25a1.5 1.5 0 0 1 1.5-1.5" }),
      t("path", { d: "m13 5.5-4.5 6-3-3m9.75.75h4.5M13 14.5l-4.5 6-3-3m9.75.75h4.5" })
    ], -1)
  ])]);
}
const V0 = { render: Qe }, H0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: V0,
  render: Qe
}, Symbol.toStringTag, { value: "Module" })), L0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Ye(o, e) {
  return n(), r("svg", L0, [...e[0] || (e[0] = [
    t("path", {
      d: "M11.848 8.377H6.623a4.623 4.623 0 1 0 0 9.247h5.225M14.152 17.623h5.225a4.623 4.623 0 1 0 0-9.247h-5.225M8.391 13h9.218",
      style: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const F0 = { render: Ye }, R0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F0,
  render: Ye
}, Symbol.toStringTag, { value: "Module" })), q0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Je(o, e) {
  return n(), r("svg", q0, [...e[0] || (e[0] = [
    t("path", {
      d: "M1.75 10.75V7a5.25 5.25 0 0 1 10.5 0v3.75",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("rect", {
      width: "16.5",
      height: "13.5",
      x: "7.75",
      y: "10.75",
      rx: "1.5",
      ry: "1.5",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M16 16v3",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const E0 = { render: Je }, D0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E0,
  render: Je
}, Symbol.toStringTag, { value: "Module" })), U0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Ke(o, e) {
  return n(), r("svg", U0, [...e[0] || (e[0] = [
    t("path", {
      d: "M13 19.49V2.155",
      style: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "m19 8.155-6-6-6 6M24 24.155H2",
      style: { fill: "none", "stroke-linecap": "square", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const G0 = { render: Ke }, N0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G0,
  render: Ke
}, Symbol.toStringTag, { value: "Module" })), W0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xe(o, e) {
  return n(), r("svg", W0, [...e[0] || (e[0] = [
    t("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      t("path", { d: "M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25" }),
      t("path", { d: "M11.75 5.75a4.262 4.262 0 1 1 0 8.524 4.262 4.262 0 0 1 0-8.524M18.75 20.325a7.913 7.913 0 0 0-14 0" })
    ], -1)
  ])]);
}
const Z0 = { render: Xe }, Q0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z0,
  render: Xe
}, Symbol.toStringTag, { value: "Module" })), Y0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function et(o, e) {
  return n(), r("svg", Y0, [...e[0] || (e[0] = [
    t("path", {
      d: "M12.998 6.251C8.967 6.183 4.798 9 2.177 11.885a1.663 1.663 0 0 0 0 2.226c2.564 2.824 6.721 5.706 10.821 5.637 4.1.069 8.258-2.813 10.824-5.637.57-.633.57-1.593 0-2.226C21.198 9 17.029 6.183 12.998 6.251",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1),
    t("path", {
      d: "M16.749 13a3.75 3.75 0 1 1-7.5.004 3.75 3.75 0 0 1 7.5-.007z",
      style: { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5px" }
    }, null, -1)
  ])]);
}
const J0 = { render: et }, K0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J0,
  render: et
}, Symbol.toStringTag, { value: "Module" })), X0 = /* @__PURE__ */ v({
  __name: "Icon",
  props: {
    size: {},
    name: {}
  },
  setup(o) {
    const e = /* @__PURE__ */ Object.assign({
      "../assets/svg/icons/AlertIcon.svg": vt,
      "../assets/svg/icons/AnalyticsIcon.svg": wt,
      "../assets/svg/icons/AppIcon.svg": xt,
      "../assets/svg/icons/AppleIcon.svg": yt,
      "../assets/svg/icons/ApprovalIcon.svg": St,
      "../assets/svg/icons/ArchiveIcon.svg": $t,
      "../assets/svg/icons/ArrowUpIcon.svg": Pt,
      "../assets/svg/icons/AudioIcon.svg": At,
      "../assets/svg/icons/AuthorIcon.svg": Lt,
      "../assets/svg/icons/BassIcon.svg": qt,
      "../assets/svg/icons/CalendarIcon.svg": Ut,
      "../assets/svg/icons/CheckIcon.svg": Wt,
      "../assets/svg/icons/ChevronUpIcon.svg": Yt,
      "../assets/svg/icons/CircleAlertIcon.svg": Xt,
      "../assets/svg/icons/CircleCheckIcon.svg": oo,
      "../assets/svg/icons/CircledSyncIcon.svg": lo,
      "../assets/svg/icons/ClockIcon.svg": co,
      "../assets/svg/icons/CoOwnerIcon.svg": uo,
      "../assets/svg/icons/CodeIcon.svg": po,
      "../assets/svg/icons/CoinIcon.svg": ho,
      "../assets/svg/icons/CopyIcon.svg": bo,
      "../assets/svg/icons/CreatedIcon.svg": Mo,
      "../assets/svg/icons/DacrIcon.svg": Io,
      "../assets/svg/icons/DacrLicenseIcon.svg": zo,
      "../assets/svg/icons/DeleteIcon.svg": To,
      "../assets/svg/icons/DenyIcon.svg": Vo,
      "../assets/svg/icons/DownloadIcon.svg": Fo,
      "../assets/svg/icons/DrumsIcon.svg": Eo,
      "../assets/svg/icons/ExternalIcon.svg": Go,
      "../assets/svg/icons/EyeIcon.svg": Zo,
      "../assets/svg/icons/FileIcon.svg": Jo,
      "../assets/svg/icons/FileSellIcon.svg": en,
      "../assets/svg/icons/FileTextIcon.svg": nn,
      "../assets/svg/icons/FilledCircleCheckIcon.svg": sn,
      "../assets/svg/icons/FilterIcon.svg": an,
      "../assets/svg/icons/GlobeIcon.svg": gn,
      "../assets/svg/icons/GoogleIcon.svg": fn,
      "../assets/svg/icons/GuitarIcon.svg": mn,
      "../assets/svg/icons/HiddenIcon.svg": kn,
      "../assets/svg/icons/HollowPlayIcon.svg": jn,
      "../assets/svg/icons/HomeIcon.svg": On,
      "../assets/svg/icons/ImageIcon.svg": Bn,
      "../assets/svg/icons/InfoIcon.svg": Cn,
      "../assets/svg/icons/LanguagesIcon.svg": Hn,
      "../assets/svg/icons/LicenseIcon.svg": Rn,
      "../assets/svg/icons/LightbulbIcon.svg": Dn,
      "../assets/svg/icons/LinkArrowIcon.svg": Nn,
      "../assets/svg/icons/LinkIcon.svg": Qn,
      "../assets/svg/icons/LoadingIcon.svg": Kn,
      "../assets/svg/icons/LockIcon.svg": t1,
      "../assets/svg/icons/MaticIcon.svg": r1,
      "../assets/svg/icons/MenuIcon.svg": i1,
      "../assets/svg/icons/MicIcon.svg": a1,
      "../assets/svg/icons/MinusIcon.svg": g1,
      "../assets/svg/icons/MoveIcon.svg": f1,
      "../assets/svg/icons/NotificationIcon.svg": m1,
      "../assets/svg/icons/OrganizationIcon.svg": k1,
      "../assets/svg/icons/PauseIcon.svg": j1,
      "../assets/svg/icons/PencilIcon.svg": O1,
      "../assets/svg/icons/PlayIcon.svg": B1,
      "../assets/svg/icons/PlusIcon.svg": C1,
      "../assets/svg/icons/ProfileIcon.svg": H1,
      "../assets/svg/icons/QuitIcon.svg": R1,
      "../assets/svg/icons/RenameIcon.svg": D1,
      "../assets/svg/icons/ReturnIcon.svg": N1,
      "../assets/svg/icons/SearchIcon.svg": Q1,
      "../assets/svg/icons/SelectIcon.svg": K1,
      "../assets/svg/icons/SendIcon.svg": t0,
      "../assets/svg/icons/SettingsIcon.svg": r0,
      "../assets/svg/icons/ShareIcon.svg": i0,
      "../assets/svg/icons/SignoutIcon.svg": a0,
      "../assets/svg/icons/SortIcon.svg": g0,
      "../assets/svg/icons/SquareInfoIcon.svg": f0,
      "../assets/svg/icons/SubsetArrowIcon.svg": m0,
      "../assets/svg/icons/SyncIcon.svg": k0,
      "../assets/svg/icons/TeamIcon.svg": j0,
      "../assets/svg/icons/TextIcon.svg": O0,
      "../assets/svg/icons/ThreeDotsIcon.svg": B0,
      "../assets/svg/icons/ThumbsUpIcon.svg": C0,
      "../assets/svg/icons/TodoIcon.svg": H0,
      "../assets/svg/icons/UnlistedIcon.svg": R0,
      "../assets/svg/icons/UnlockedIcon.svg": D0,
      "../assets/svg/icons/UploadIcon.svg": N0,
      "../assets/svg/icons/UserIcon.svg": Q0,
      "../assets/svg/icons/VisibleIcon.svg": K0
    }), l = o, s = c(() => ({
      minWidth: l.size ? `${l.size}px` : "100%",
      maxWidth: l.size ? `${l.size}px` : "100%",
      height: l.size ? `${l.size}px` : "100%"
    }));
    return (i, d) => (n(), r("div", {
      id: "iconComponent",
      class: "flex items-center justify-center",
      style: dt(s.value)
    }, [
      (n(), b(ct(at(e)[`../assets/svg/icons/${l.name}Icon.svg`]), { class: "w-full h-full" }))
    ], 4));
  }
}), lr = (o, e) => {
  const l = o.__vccOpts || o;
  for (const [s, i] of e)
    l[s] = i;
  return l;
}, sr = /* @__PURE__ */ v({
  __name: "Checkbox",
  props: {
    modelValue: { type: Boolean },
    indeterminate: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const l = o, s = e, i = c(() => l.modelValue), d = c(() => i.value || l.indeterminate), g = c(() => i.value ? "Check" : l.indeterminate ? "Minus" : ""), _ = () => {
      s("update:modelValue", !i.value);
    }, p = c(() => ({
      "pointer-events-none": l.disabled
    })), tt = c(() => ({
      ...d.value && {
        "bg-green-900 border-transparent": !0,
        "bg-gray-500/45!": l.disabled
      },
      ...!d.value && {
        "bg-gray-200/15": l.disabled
      },
      "group-hover/checkbox:bg-gray-200/10 group-hover/checkbox:border-gray-300/50": !i.value && !l.indeterminate
    })), ot = c(() => ({
      "opacity-70": l.disabled
    })), nt = c(() => ({
      "text-gray-500! opacity-50": l.disabled
    }));
    return (h, er) => (n(), r("div", {
      class: f(["group/checkbox w-fit flex items-center cursor-pointer select-none border-gray-200/75", p.value]),
      onClick: _
    }, [
      t("div", {
        class: f(["size-5 border border-[inherit] rounded-sm flex justify-center items-center", tt.value])
      }, [
        d.value ? (n(), b(X0, {
          key: 0,
          name: g.value,
          size: 12,
          class: f(["stroke-white", ot.value])
        }, null, 8, ["name", "class"])) : m("", !0)
      ], 2),
      h.$slots.default ? (n(), r("div", {
        key: 0,
        class: f(["mt-px ml-2.5 font-secondary text-[14px] leading-[18px] text-gray-800", nt.value])
      }, [
        _t(h.$slots, "default")
      ], 2)) : m("", !0)
    ], 2));
  }
});
export {
  or as F,
  X0 as _,
  lr as a,
  nr as b,
  rr as c,
  sr as d
};
